import { Divider, Stack, Typography } from '@mui/material';

import AccountingIllustrationPanel, {
    ILLUSTRATION_LAYOUT_SLOT_PROPS,
} from 'modules/Onboarding/AccountingSetup/components/AccountingIllustrationPanel';
import DocumentCheckIcon from 'modules/common/components/Icons/DocumentCheckIcon';
import PresentationChartLineIcon from 'modules/common/components/Icons/PresentationChartLineIcon';
import RichStepList, { RichStepType, type RichStep } from 'modules/common/components/RichStepList';
import SplitPanelLayout from 'modules/common/components/SplitPanelLayout';

const INTRO_STEPS: RichStep[] = [
    {
        type: RichStepType.Icon,
        icon: DocumentCheckIcon,
        title: 'Complete your books',
        description: 'Give us the information we need to finalize your accounting setup.',
    },
    {
        type: RichStepType.Icon,
        icon: PresentationChartLineIcon,
        title: 'Stay on top of your finances',
        description: 'Get accurate reports to understand how your business is doing.',
    },
];

export default function AccountingSetupIntro() {
    return (
        <SplitPanelLayout
            leftContent={
                <Stack spacing={4}>
                    <Typography variant="h1">
                        Now that your accounts are connected, you can get your books ready
                    </Typography>
                    <Stack spacing={2}>
                        <Typography variant="body1">
                            We&apos;ll help you complete your books and get a clear view of how your business is doing.
                        </Typography>
                        <Divider />
                    </Stack>
                    <RichStepList steps={INTRO_STEPS} />
                </Stack>
            }
            rightContent={<AccountingIllustrationPanel />}
            slotProps={ILLUSTRATION_LAYOUT_SLOT_PROPS}
        />
    );
}
